// Bootstrap の必要なコンポーネントのみをインポート
export { Modal } from 'bootstrap/js/dist/modal'
export { Toast } from 'bootstrap/js/dist/toast'
export { Tab } from 'bootstrap/js/dist/tab'
export { Collapse } from 'bootstrap/js/dist/collapse'
export { Alert } from 'bootstrap/js/dist/alert'

// 必要に応じて他のコンポーネントを追加
// export { Dropdown } from 'bootstrap/js/dist/dropdown'